import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-686fa83e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-list" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }

import ArrowDown from "@/icons/common/arrow-down.vue";
import { SelectItem } from "@/types/select-list";
import SelectListItem from "./components/select-list-item.vue";
import { PropType, ref, computed } from "vue";
import { onClickOutside } from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  items: {
    type: Object as PropType<Array<SelectItem>>,
    default: () => ({}),
  },
  select: {
    type: Object as PropType<SelectItem>,
    default: () => ({}),
  },
  isMinify: {
    type: Boolean,
    default: false,
  },
  isListImage: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:select"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const isOpen = ref<boolean>(false);
const dropdown = ref(null);
const toggle = ref(null);

__expose({ isOpen });





const listItems = computed<Array<SelectItem>>(() => {
  if (!props.items.length) return [];
  return props.items.filter((item) => item.id !== props.select.id);
});

const toggleAction = () => {
  isOpen.value = !isOpen.value;
};
const selectItem = (item: SelectItem) => {
  emit("update:select", item);
  toggleAction();
};
onClickOutside(
  dropdown,
  () => {
    if (isOpen.value) isOpen.value = false;
  },
  { ignore: [toggle] }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      ref_key: "toggle",
      ref: toggle,
      class: "select-list__block",
      onClick: toggleAction
    }, [
      _createElementVNode("img", {
        src: __props.select.image
      }, null, 8, _hoisted_2),
      (!__props.isMinify)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.select.name), 1))
        : _createCommentVNode("", true),
      _createVNode(ArrowDown)
    ], 512),
    _withDirectives(_createElementVNode("div", {
      ref_key: "dropdown",
      ref: dropdown,
      class: "select-list__dropdown"
    }, [
      _createVNode(SelectListItem, {
        item: __props.select,
        "is-selected": true,
        "is-list-image": __props.isListImage,
        "onUpdate:select": toggleAction
      }, null, 8, ["item", "is-list-image"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listItems.value, (item, index) => {
        return (_openBlock(), _createBlock(SelectListItem, {
          key: index,
          item: item,
          "is-list-image": __props.isListImage,
          "onUpdate:select": selectItem
        }, null, 8, ["item", "is-list-image"]))
      }), 128))
    ], 512), [
      [_vShow, isOpen.value]
    ])
  ]))
}
}

})